import { AuthResponse } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'
import { InternalRoles } from '../utils'

export const ApplicationsFeature = {
  // Roles that are excluded from the Applications feature
  BlockedRoles: InternalRoles,

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    !hasRole(ApplicationsFeature.BlockedRoles, user),
} satisfies Feature
